import { Tour } from '../types';

const ARCHIVE_RETENTION_YEARS = 2;

/**
 * A tour is archived once its return date has passed.
 * Archived tours are hidden from the public site and shown under
 * the Archived tab in admin until permanently deleted.
 */
export function isTourArchived(tour: Tour): boolean {
  if (!tour.returnDate) return false;
  const returnDate = new Date(tour.returnDate);
  if (Number.isNaN(returnDate.getTime())) return false;
  return returnDate.getTime() < Date.now();
}

/**
 * Date when an archived tour will be permanently deleted
 * (return date + 2 years). Returns null if return date is missing/invalid.
 */
export function getTourAutoDeleteDate(tour: Tour): Date | null {
  if (!tour.returnDate) return null;
  const returnDate = new Date(tour.returnDate);
  if (Number.isNaN(returnDate.getTime())) return null;
  const deleteDate = new Date(returnDate);
  deleteDate.setFullYear(deleteDate.getFullYear() + ARCHIVE_RETENTION_YEARS);
  return deleteDate;
}
